import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from 'react-hook-form';
import { InputControl } from '@si-armes/dsfr-react';
import { getDateFormatWithSlash } from 'components/Commun/Form/maskFunctions';
import { REGEXP_DATE_DE_NAISSANCE_FR, REGEXP_DATE_DE_NAISSANCE_FR_AVANT_1900 } from './regex';

const DateDeNaissanceInput = ({
    name,
    required,
    label,
    disabled,
    verificationMajorite,
    avant1900,
    ...otherProps
}) => {
    const { formState, register } = useFormContext();

    const checkFormat = (valeur) => {
        const regex = avant1900
            ? REGEXP_DATE_DE_NAISSANCE_FR_AVANT_1900
            : REGEXP_DATE_DE_NAISSANCE_FR;

        if (!valeur || (valeur && valeur.length === 10 && regex.exec(valeur))) {
            return null;
        }

        return 'Le format est incorrect';
    };

    const checkNoFuture = (valeur) => {
        if (valeur) {
            const dateDecoupee = valeur.split('/');

            if (
                new Date(dateDecoupee[2], dateDecoupee[1] - 1, dateDecoupee[0]).getTime() >=
                new Date().getTime()
            ) {
                return 'La date renseignée ne doit pas être supérieure à la date du jour';
            }
        }

        return null;
    };

    const checkMajorite = (valeur) => {
        if (valeur && verificationMajorite) {
            const dateDecoupee = valeur.split('/');
            const jourDeNaissance = dateDecoupee[0] === '00' ? '01' : dateDecoupee[0];
            const moisDeNaissance = dateDecoupee[1] === '00' ? '01' : dateDecoupee[1];
            const anneeDeNaissance = dateDecoupee[2];
            const difference =
                Date.now() -
                new Date(anneeDeNaissance, moisDeNaissance - 1, jourDeNaissance).getTime();
            const age = Math.abs(new Date(difference).getUTCFullYear() - 1970);

            if (age < 18) {
                return 'L’Espace Détenteurs n’est pas encore ouvert aux détenteurs mineurs';
            }
        }

        return null;
    };

    return (
        <InputControl
            autocomplete="bday"
            label={label}
            placeholder="JJ/MM/AAAA"
            maskFonction={getDateFormatWithSlash}
            {...register(name, {
                required: required ? 'Ce champs est requis' : null,
                validate: {
                    validateFormat: checkFormat,
                    noFuture: checkNoFuture,
                    verificationMajorite: checkMajorite,
                },
            })}
            required={required}
            state={formState.errors?.[name] ? 'error' : ''}
            message={formState.errors?.[name]?.message}
            disabled={disabled}
            {...otherProps}
        />
    );
};

DateDeNaissanceInput.propTypes = {
    name: PropTypes.string.isRequired,
    required: PropTypes.bool,
    verificationMajorite: PropTypes.bool,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    avant1900: PropTypes.bool,
};

export default DateDeNaissanceInput;
